var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49998 1.5L4.49095 4.49097M16.5 16.5L13.5093 13.5093M10.5624 14.6872C10.0564 14.7831 9.53425 14.8333 9.00036 14.8333C5.26898 14.8333 2.1104 12.3809 1.04852 8.99997C1.3376 8.07958 1.78207 7.22801 2.35117 6.47598M7.23221 7.23223C7.68462 6.77982 8.30962 6.5 8.99998 6.5C10.3807 6.5 11.5 7.61929 11.5 9C11.5 9.69036 11.2202 10.3154 10.7677 10.7678M7.23221 7.23223L10.7677 10.7678M7.23221 7.23223L4.49095 4.49097M10.7677 10.7678L4.49095 4.49097M10.7677 10.7678L13.5093 13.5093M4.49095 4.49097C5.7908 3.65295 7.33878 3.16667 9.00035 3.16667C12.7317 3.16667 15.8903 5.61909 16.9522 9.00003C16.3631 10.8756 15.1287 12.4654 13.5093 13.5093",
    stroke: "#94959C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.9ea5cd71f1d0bee62eb4a043a197b5f3.svg";
export { ForwardRef as ReactComponent };